import { el, showToast, t } from './dom';
import { api, ApiError } from './api';

export function openChangePasswordModal() {
  const backdrop = el('div', { className: 'modal-backdrop' });
  const modal = el('div', { className: 'modal' });
  modal.appendChild(el('h3', { text: t('account.changePassword') }));

  // Campo: contraseña actual
  const currentGroup = el('div', { className: 'form-group' });
  currentGroup.appendChild(el('label', { text: t('account.currentPassword') }));
  const currentInput = document.createElement('input');
  currentInput.type = 'password';
  currentInput.autocomplete = 'current-password';
  currentGroup.appendChild(currentInput);

  // Campo: nueva contraseña
  const newGroup = el('div', { className: 'form-group' });
  newGroup.appendChild(el('label', { text: t('account.newPassword') }));
  const newInput = document.createElement('input');
  newInput.type = 'password';
  newInput.autocomplete = 'new-password';
  newGroup.appendChild(newInput);

  // Campo: confirmar
  const confirmGroup = el('div', { className: 'form-group' });
  confirmGroup.appendChild(el('label', { text: t('account.confirmPassword') }));
  const confirmInput = document.createElement('input');
  confirmInput.type = 'password';
  confirmInput.autocomplete = 'new-password';
  confirmGroup.appendChild(confirmInput);

  const actions = el('div', { className: 'modal-actions' });
  const cancelBtn = el('button', {
    className: 'btn btn-secondary',
    text: t('common.cancel'),
    onClick: () => backdrop.remove(),
  });
  const saveBtn = el('button', {
    className: 'btn btn-primary',
    text: t('common.save'),
    onClick: async () => {
      const current = currentInput.value;
      const newPwd = newInput.value;
      const confirm = confirmInput.value;

      if (!current || !newPwd || !confirm) {
        showToast(t('common.requiredField'), 'error');
        return;
      }
      if (newPwd.length < 8) {
        showToast(t('account.passwordMin'), 'error');
        return;
      }
      if (newPwd !== confirm) {
        showToast(t('account.passwordsDontMatch'), 'error');
        return;
      }

      saveBtn.disabled = true;
      try {
        await api.request('POST', '/me/change-password', {
          currentPassword: current,
          newPassword: newPwd,
        });
        showToast(t('account.passwordChanged'), 'success');
        backdrop.remove();
      } catch (e) {
        const msg = e instanceof ApiError ? e.message : t('common.unknownError');
        showToast(msg, 'error');
        saveBtn.disabled = false;
      }
    },
  });
  actions.append(cancelBtn, saveBtn);

  modal.append(currentGroup, newGroup, confirmGroup, actions);
  backdrop.appendChild(modal);
  document.body.appendChild(backdrop);
  setTimeout(() => currentInput.focus(), 50);
}
